export interface ScoreboardRow {
  influencer_id: number
  topic: string
  total_predictions: number
  correct: number
  incorrect: number
  partial: number
  unverified: number
}

export interface ScoreboardInfluencer {
  id: number
  name: string
  prediction_count?: number | string
}

export interface KolTotals {
  extracted: number
  inWindow: number
  correct: number
  incorrect: number
  partial: number
  unverified: number
  scored: number
  pct: number | null
  windowShare: number | null
}

function coercePredictionCount(raw: number | string | undefined | null): number {
  if (raw === undefined || raw === null) return 0
  const n = Number(raw)
  return Number.isFinite(n) ? n : 0
}

export function computeScoreboardTotals(
  rows: ScoreboardRow[],
  influencers: ScoreboardInfluencer[],
): Record<number, KolTotals> {
  const byInfluencer: Record<number, ScoreboardRow[]> = {}
  for (const row of rows) {
    if (!byInfluencer[row.influencer_id]) byInfluencer[row.influencer_id] = []
    byInfluencer[row.influencer_id].push(row)
  }

  const result: Record<number, KolTotals> = {}
  for (const inf of influencers) {
    const extracted = coercePredictionCount(inf.prediction_count)
    const rs = byInfluencer[inf.id] ?? []
    const inWindow = rs.reduce((s, r) => s + r.total_predictions, 0)
    const correct = rs.reduce((s, r) => s + r.correct, 0)
    const incorrect = rs.reduce((s, r) => s + r.incorrect, 0)
    const partial = rs.reduce((s, r) => s + r.partial, 0)
    const unverified = rs.reduce((s, r) => s + r.unverified, 0)
    const scored = correct + incorrect + partial
    const pct = scored > 0 ? Math.round((correct / scored) * 100) : null
    const windowShare = extracted === 0 ? null : Math.min(100, Math.round((inWindow / extracted) * 100))

    result[inf.id] = { extracted, inWindow, correct, incorrect, partial, unverified, scored, pct, windowShare }
  }

  return result
}
